import type { ReactNode } from "preact/compat";
import { createContext, useContext, useMemo } from "preact/compat";
import { createIpInfoGeolocationService } from "@brickme/frontend-common/src/ip-info/ip-info-service.ts";
import type { IpGeolocationService } from "@brickme/frontend-common/src/ip-info/ip-info-service.ts";

type ContextValue = {
	readonly locationService: IpGeolocationService;
};

const Context = createContext<ContextValue | undefined>(undefined);

type LocationProviderProps = {
	readonly children: ReactNode;
	readonly ipInfoToken: string;
};

function LocationProvider({ children, ipInfoToken }: LocationProviderProps) {
	const locationService = useMemo(() => {
		return createIpInfoGeolocationService(ipInfoToken);
	}, [ipInfoToken]);
	return (
		<Context.Provider value={{ locationService }}>{children}</Context.Provider>
	);
}

function useLocationService() {
	const value = useContext(Context);
	if (!value) {
		throw new Error("No theme context");
	}
	return value.locationService;
}

export { useLocationService, LocationProvider };
